var t=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";return t||n?"(".concat("".concat(t," ").concat(n).trim(),")"):""};export{t as default};
